import { render, staticRenderFns } from "./HeaderUser.vue?vue&type=template&id=6f280b98&scoped=true&"
import script from "./HeaderUser.vue?vue&type=script&lang=js&"
export * from "./HeaderUser.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUser.vue?vue&type=style&index=0&id=6f280b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f280b98",
  null
  
)

export default component.exports